import dayjs, { DATE_FORMATS } from './dateUtils';

/**
 * Generates a standardized file name based on project name, context, date, and time.
 *
 * @param {Object} options - File name generation options.
 * @param {string} options.name - Required base name of the file (e.g., project name).
 * @param {string} [options.context=''] - Optional context describing the content.
 * @param {string} [options.ext='txt'] - File extension (e.g., 'txt', 'json').
 * @returns {string} Generated file name in the format: [name]_[context]_[DD-MM-YYYY]_[HHmmss].[ext]
 *
 * @example
 * generateFileName({ name: 'TestName', context: 'test', ext: 'txt' });
 * // "TestName_test_12-05-2025_135412.txt"
 *
 * generateFileName({ name: 'Logs' });
 * // "Logs_12-05-2025_135412.txt"
 */
function generateFileName({ name, context = '', ext = 'txt' }) {
  if (!name || typeof name !== 'string') {
    throw new Error('`name` is required');
  }

  const safeName = sanitize(name);
  const safeContext = sanitize(context);
  const timestamp = dayjs().format(DATE_FORMATS.FILENAME_TIMESTAMP);
  const contextPart = safeContext ? `_${safeContext}` : '';

  return `${safeName}${contextPart}_${timestamp}.${ext}`;
}

export default generateFileName;

const sanitize = (str) => str.replace(/[\\/:"*?<>|]+/g, '_');
